export default __webpack_public_path__ + "static/media/faisal.5bfb75eb.jpg";